import * as noUiSlider from 'nouislider';

let slider = {
    sliderEl: null,
    noUiSliderInstance: null,
    initSlider: function (elementId) {
        this.sliderEl = document.getElementById(elementId);
        if (this.noUiSliderInstance !== null) {
            this.noUiSliderInstance.destroy();
        }

        if (this.sliderEl) {
            this.noUiSliderInstance = noUiSlider.create(this.sliderEl, {
                start: [this.sliderEl.dataset.min, this.sliderEl.dataset.max],
                connect: true,
                step: 100, 
                range: {
                    'min': parseInt(this.sliderEl.dataset.min),
                    'max': parseInt(this.sliderEl.dataset.max)
                }
            });
            this.registerUpdateEvent();
            this.registerChangeEvent(); 
            this.registerInputChangeEvent(); 
            this.preventNonNumericInput();
        }
    },
    registerUpdateEvent: function () {
        const marginMaxInput = document.getElementById('rent-max-input');
        this.sliderEl.noUiSlider.on('update', function (values, handle) {
            var value = parseInt(values[handle]).toLocaleString('sv-SE', { maximumFractionDigits: 0 });
            if (handle) {

                marginMaxInput.value = value;
            }
        });
    },
    registerChangeEvent: function () {
        const marginMaxInput = document.getElementById('rent-max-input');
        var event = new Event('change');
        this.sliderEl.noUiSlider.on('change', function (values, handle) {
            var value = parseInt(values[handle]).toFixed(0);

            if (handle) {
                marginMaxInput.value = parseInt(value).toLocaleString('sv-SE');
                marginMaxInput.dispatchEvent(event);
            }
        });
    },
    registerInputChangeEvent: function () {
        const marginMaxInput = document.getElementById('rent-max-input');
        const sliderInstance = this.sliderEl.noUiSlider;

        marginMaxInput.addEventListener('change', function () {
            let newValue = parseInt(marginMaxInput.value.replace(/\s/g, '')); 
            const sliderMin = parseInt(sliderInstance.options.range.min);
            const sliderMax = parseInt(sliderInstance.options.range.max);

            if (isNaN(newValue) || newValue < sliderMin) {
                newValue = sliderMin;
            }
            if (newValue > sliderMax) {
                newValue = sliderMax;
            }

            newValue = Math.ceil(newValue / 100) * 100;

            let currentMin = sliderInstance.get()[0];
            sliderInstance.set([currentMin, newValue]);
            slider.sliderEl.setAttribute('title', `Värdet är ${newValue.toLocaleString('sv-SE')} kr`);
        });
    },
    preventNonNumericInput: function () {
        const marginMaxInput = document.getElementById('rent-max-input');
        marginMaxInput.addEventListener('input', function () {
            let value = marginMaxInput.value.replace(/\s/g, ''); 
            value = value.replace(/\D/g, '');
            marginMaxInput.value = value ? parseInt(value).toLocaleString('sv-SE') : ''; 
        });
    },
    resetSlider: function () {
        this.sliderEl.noUiSlider.set([this.sliderEl.dataset.min, this.sliderEl.dataset.max], true);
    }
};

export { slider };